import { useQuery } from '@tanstack/react-query'
import type { UseQueryResult } from '@tanstack/react-query'
import { useParams } from 'next/navigation'
import { QUERY_HOTEL_DETAIL_KEY, fetchHotelDetail } from './fetchHotelDetail'
import useAuthentication from '../useAuthentication'
import type { HotelDetailModel } from 'core/hotels/types'

function useQueryHotelDetail(
  hotelCode: string,
): UseQueryResult<HotelDetailModel | null> {
  const params = useParams<{ locale: string }>()
  const { locale } = params || {}
  const { withTriplaApiRequest } = useAuthentication()

  return useQuery({
    queryKey: [QUERY_HOTEL_DETAIL_KEY, { hotelCode, locale }],
    queryFn: withTriplaApiRequest(fetchHotelDetail),
    enabled: !!hotelCode,
  })
}

export default useQueryHotelDetail
